import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 44000-44999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const projectExternalErrors = {
  // 44xxx projectTemplates. Its session-user site reused SESSION_USER_ACCOUNT_GONE (7088).
  PROJECT_TEMPLATE_NOT_FOUND_IN_PORTAL: {
    errorCode: 44001,
    errorMessage: t("No Project Template matched the id in this Portal."),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_NOT_FOUND: {
    errorCode: 44002,
    errorMessage: t("No such template exists"),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_DELETE_FAILED: {
    errorCode: 44003,
    errorMessage: t("Error deleting template"),
    isDynamic: false,
  },
  // 44004-44007 came off NO_CHANGES_APPLIED (9005).
  PROJECT_TEMPLATE_UNCHANGED: {
    errorCode: 44004,
    errorMessage: t("Project Template was not updated."),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_SPACE_UNCHANGED: {
    errorCode: 44005,
    errorMessage: t("Space was not updated."),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_SPACE_ALREADY_DELETED: {
    errorCode: 44006,
    errorMessage: t("That space is already deleted."),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_SPACE_DELETE_FAILED: {
    errorCode: 44007,
    errorMessage: t("The space could not be deleted — the project template was not modified."),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_DATA_REQUIRED: {
    errorCode: 44008,
    errorMessage: t("Template data is required"),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_SPACE_EDIT_FIELD_REQUIRED: {
    errorCode: 44009,
    errorMessage: t("Either 'isDefault' or 'name' must be provided to edit a space"),
    isDynamic: false,
  },
  PROJECT_TEMPLATE_SPACE_ID_REQUIRED: {
    errorCode: 44010,
    errorMessage: t("Space ID is required"),
    isDynamic: false,
  },
  PROJECT_ID_ALREADY_EXISTS: {
    errorCode: 44011,
    errorMessage: t("A project with this ProjectId already exists in this portal."),
    isDynamic: false,
  },
  PROJECT_NOT_FOUND_BY_PROJECT_ID: {
    errorCode: 44012,
    errorMessage: t("Project does not exists with given projectId"),
    isDynamic: false,
  },
  PROJECT_PORTAL_ID_REQUIRED: {
    errorCode: 44013,
    errorMessage: t("Portal Id is required"),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
